import { render } from "./JobtitleDropdown.vue?vue&type=template&id=090da1fa"
import script from "./JobtitleDropdown.vue?vue&type=script&lang=js"
export * from "./JobtitleDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__